import React from 'react'
import { ProductDataShape } from './ProductDataShape'
import ReactDOM from 'react-dom'
import { throwErrorInline } from './utils/throwErrorInline'
import { getProductImageUrl } from './products/getProductImageUrl'
import { IconCross } from './components/icons'
import Button from './components/Button'
import FillImageView from './components/FillImageView'
import { PlaceholderInterfaceError } from './data/placeholderImages'
import { SkinProductOption } from './types/productTypes'

function getElementId(product: SkinProductOption) {
  return `debugskin-${product.itemNo}-${product.orientation}`
}

export const ProductDebugList: React.FC<{
  products: ProductDataShape
  onClose: () => void
}> = ({ products, onClose }) => {
  const [filter, setFilter] = React.useState('')

  return ReactDOM.createPortal((
    <div
      style={{
        position: 'fixed',
        background: '#fffd',
        backdropFilter: 'blur(10px)',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        overflowY: 'auto',
        zIndex: 10000000,
        padding: '20px 100px',
      }}
    >
      <div
        style={{
          display: 'flex',
          position: 'sticky',
          top: 0,
          zIndex: 10,
          paddingBottom: '30px',
        }}
      >
        <input
          type="text"
          value={filter}
          onChange={e => setFilter(e.target.value)}
          placeholder="Filter products..."
          style={{
            flex: '1 1 0',
            marginRight: '20px',
          }}
        />
        <Button
          buttonStyle="redStroke"
          round
          onClick={onClose}
        >
          <img src={IconCross} alt="Cancel" />
        </Button>
      </div>
      {
        products.skinGridProducts.filter(
          it => it.itemNo.includes(filter)
            || it.description.includes(filter)
            || it.displayName.includes(filter)
            || it.itemNo.includes(filter)
        ).map(product => {
          const explicitOther = product.otherOrientation !== null
            ? products.skinGridProducts.find(it => it.itemNo === product.otherOrientation)
            ?? throwErrorInline('other orientation missing')
            : null

          const rotated = products.skinGridProducts.find(it => it.itemNo === product.itemNo && it.orientation !== product.orientation) ?? null

          const other = explicitOther ?? rotated

          const grid = product.gridProduct
          const grids = grid
            ? (
              grid.standaloneGridItemNo
                ? products.grids.filter(otherGrid => otherGrid.standaloneGridItemNo === grid.standaloneGridItemNo || otherGrid.itemNo === grid.itemNo)
                : [grid]
            )
            : []

          return (
            <div
              key={`${product.itemNo} ${product.orientation}`}
              id={getElementId(product)}
              style={{
                padding: '30px 0',
                borderTop: '1px solid #0005',
              }}
            >
              <div>
                <strong>{product.itemNo}</strong>
                <br/>
                <strong>{product.displayName}</strong>
                <br/>
                {product.description}
              </div>
              <div
                style={{
                  display: 'flex',
                  marginBottom: '20px',
                  alignItems: 'center',
                  padding: '10px 0 10px 0'
                }}
              >
                <div
                  style={{
                    width: '100px',
                    height: '100px',
                    transform: (product.orientation !== product.imageOrientation) ? 'rotate(90deg)' : undefined,
                    position: 'relative',
                  }}
                >
                  <FillImageView src={getProductImageUrl(product.image)} placeholder={PlaceholderInterfaceError} />
                </div>
                <div
                  style={{
                    margin: '0 20px',
                  }}
                >
                  Other Orientation:
                </div>
                <a
                  href={other ? `#${getElementId(other)}` : undefined}
                  title={other?.itemNo}
                  style={{
                    width: '100px',
                    height: '100px',
                    backgroundImage: other ? undefined : 'linear-gradient(45deg, #0000 49%, #000 49%, #000 51%, #0000 51%)',
                    transform: (other && other === rotated && rotated.orientation !== rotated.imageOrientation) ? 'rotate(90deg)' : undefined,
                    backgroundSize: 'contain',
                    backgroundOrigin: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative',
                    border: other ? '1px solid #00f' : undefined,
                  }}
                >
                  {
                    other && (
                      <FillImageView src={getProductImageUrl(other.image)} placeholder={PlaceholderInterfaceError} />
                    )
                  }
                </a>
              </div>
              {
                grids.length > 0 && (
                  <>
                    <div>
                      <strong>Compatible Grids:</strong>
                    </div>
                    <ul>
                      {grids.map(grid => (
                        <li key={grid.itemNo}>
                          <strong>{grid.itemNo}</strong> {grid.description}
                          <ul>
                            <li>Mech: <strong>{grid.includedMechItemNo ?? '-'}</strong></li>
                            <li>Skin: <strong>{grid.includedSkinItemNo ?? '-'}</strong></li>
                            <li>Orientations: <strong>{grid.orientation}</strong></li>
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </>
                )
              }
            </div>
          )
        })
      }
    </div>
  ), document.body)
}